import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsUpdateCompanyBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Update company</div>
          <div className="text">
            Given a company ID, this endpoint updates the company with the data supplied
          </div>
          <div className="text">
            If you have company syncing integrations in place (e.g., Hubspot, Salesforce, SSO
            Tokens, Canny Identify, ...), the fields updated with this endpoint might be
            overwritten.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: 'The identifier for your company.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'The date the company was created in your system.',
                heading: 'created',
                subheading: 'date (optional)',
              },
              {
                description:
                  'Any custom fields associated with the company. Each field name (key) must be between 0 and 30 characters long. If field values are strings, they must be less than 200 characters long.',
                heading: 'customFields',
                subheading: 'object (optional)',
              },
              {
                description:
                  'The MRR for the company in dollars. This will be rounded to two decimal places.',
                heading: 'monthlySpend',
                subheading: 'integer (optional)',
              },
              {
                description: "The company's name. Must be between 0 and 100 characters long.",
                heading: 'name',
                subheading: 'string (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Upon success, returns an object with a single key: id.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/companies/update</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/companies/update"
            body={`-d '{
    "apiKey": "YOUR_API_KEY",
    "id": "company1",
    "created": "${this.createdAt.toISOString()}",
    "customFields": {
      "number": "12",
      "string": "value"
      "boolean": true,
    },
    "monthlySpend": 500.59,
    "name": "company 1"}' \\
    -H "Content-Type: application/json"`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">{`{
  "id": "company1"
}`}</Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
